<template>
  <div
    class="container"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <div class="prize-header flex-between">
      <div>
        <p class="prize-title">待提现（元）</p>
        <p class="prize-reward">{{canWithdraw}}</p>
      </div>
      <van-button
        type="default"
        class="prize-btn hairline"
        @click="extractive"
      >提现</van-button>
    </div>
    <div class="content">
      <van-tabs
        v-model="active"
        line-width="28"
        line-height="3"
        color="#FF1310"
        background="#F5F5F5"
        title-active-color="#FF1310"
        title-inactive-color="#262626"
        swipeable
        @change="changeTab"
      >
        <van-tab
          title="收入"
          name="1"
        >
          <van-list
            v-model="isUpLoading"
            :finished="finished"
            :finished-text="!list1.length?'':'没有更多了'"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="streamList"
          >
            <div
              class="common"
              v-for="(item,index) in list1"
              :key="index"
            >
              <div class="flex-between">
                <p>到账时间</p>
                <p style="color: #262626">{{item.finishtime}}</p>
              </div>
              <div class="flex-between">
                <p>订单编号</p>
                <p style="color: #262626">{{item.orderSn}}</p>
              </div>
              <div class="flex-between">
                <p>佣金</p>
                <p style="color: #FF1310">¥{{item.money}}</p>
              </div>
            </div>
            <div v-show="!list1.length&&!isUpLoading&&!error">
              <div class="notHave">
                <img
                  src="../../assets/img/pic_ordermiss.png"
                  alt
                />
                <p>暂无相关记录</p>
              </div>
            </div>
          </van-list>
        </van-tab>
        <van-tab
          title="提现记录"
          name="2"
        >
          <van-list
            v-model="isUpLoading"
            :finished="finished"
            :finished-text="!list2.length?'':'没有更多了'"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="streamList"
          >
            <div
              class="common"
              v-for="(item,index) in list2"
              :key="index"
              @click="goToDetail(item)"
            >
              <div class="flex-between">
                <p>{{item.finishtime}}</p>
                <p style="color: #262626">提现成功</p>
              </div>
              <div class="flex-between">
                <p>{{item.bankName}}（{{item.cardNo}}）</p>
                <p style="color: #262626">¥{{item.money}}</p>
              </div>
            </div>
            <div v-show="!list2.length&&!isUpLoading&&!error">
              <div class="notHave">
                <img
                  src="../../assets/img/pic_ordermiss.png"
                  alt
                />
                <p>暂无相关记录</p>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import inobounce from 'inobounce';
import { getBindingCardList, streamList, myShop } from "@/api/join";
export default {
  data() {
    return {
      active: 1,
      isUpLoading: false,
      finished: true,
      list1: [],
      list2: [],
      pageIndex: 1,
      error: false,
      canWithdraw: "",
    };
  },
  methods: {
    goToDetail(item) {
      this.$router.push({
        name: "withdrawDetail",
        path: "/withdrawDetail",
        params: {
          detail: JSON.stringify(item),
        },
      });
    },
    extractive() {
      getBindingCardList({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          let backCardList = res.content;
          if (!backCardList.length) {
            this.$dialog.alert({
              message: "<b>未绑定银行卡，请前往绑定<br/>才能提现<b/>",
              showCancelButton: true,
              confirmButtonText: "添加银行卡",
              cancelButtonText: "取消",
              confirmButtonColor: "#FF3838",
              cancelButtonColor: "#1993FF",
            })
              .then(() => {
                this.$router.push({
                  name: "register",
                  path: "/register",
                  params: {
                    backCardList: JSON.stringify(backCardList),
                  },
                });
              });
          } else {
            let backCardInfo = {
              canWithdraw: this.canWithdraw,
              backCardList: backCardList,
            };
            this.$router.push({
              name: "withdrawDeposit",
              path: "/withdrawDeposit",
              params: {
                backCardInfo: JSON.stringify(backCardInfo),
              },
            });
          }
        }
      });
    },
    changeTab() {
      // 清空列表数据
      this.pageIndex = 1;
      this.finished = false;
      this["list" + this.active] = [];
      this.isUpLoading = true;
      this.error = false;
      this.streamList();
    },
    streamList() {
      streamList({
        payType: this.active, // 1收入 2支出
        page: {
          way: "1", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "20", //数量
        },
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            const list = res.content.list;
            if (list.length < 10) {
              // 最后一页不足10条的情况
              this.finished = true;
            }
            // 处理数据
            if (this.pageIndex === 1) {
              this.orderList = list;
              this["list" + this.active] = list;
            } else {
              this.orderList = this.orderList.concat(list);
              this["list" + this.active] = this["list" + this.active].concat(
                list
              );
            }
            this.pageIndex++;
          } else {
            this.error = true;
          }
          this.isUpLoading = false;
        })
        .catch((res) => {
          this.error = true;
          this.isUpLoading = false;
        });
    },
    myShop() {
      myShop({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.canWithdraw = res.content.canWithdraw;
        }
      });
    },
    isiOS() {
      let u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/withdrawSuccess" || to.path == "/extractCode") {
      if (this.$store.getters.ambientType == 0) {
        wx.miniProgram.navigateBack({ delta: 9999 });
      } else {
        this.$router.push("/personal");
      }
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (
      from.path == "/withdrawDetail" ||
      from.path == "/register" ||
      from.path == "/withdrawDeposit"
    ) {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (this.isiOS()) {
      // 取消iOS系统中滑动回弹效果(橡皮筋效果)
      inobounce.enable();
    }
    if (!this.$route.meta.isBack) {
      if (this.active == 1) {
        this.changeTab();
        this.myShop();
      } else {
        this.active = 1;
      }
    }
    this.$route.meta.isBack = false;
  },
  deactivated() {
    if (this.isiOS()) {
      inobounce.disable();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 44px);
}
.cover {
  height: 100%;
}
.prize-header {
  width: 312px;
  height: 125px;
  margin: 20px auto 10px;
  padding: 0 18px;
  background: linear-gradient(90deg, #38a7fc 0%, #208fff 100%);
  box-shadow: 0px 2px 6px rgba(32, 143, 255, 0.4);
  border-radius: 10px;
  .prize-title {
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
  }
  .prize-reward {
    font-size: 34px;
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
    margin-top: 6px;
  }
  .prize-btn {
    width: 74px;
    height: 32px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    background-color: inherit;
    border-radius: 25px;
    box-sizing: border-box;
    text-align: center;
  }
}

.flex-between {
  align-items: center;
}

.content {
  flex: 1;
  text-align: left;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  .common {
    margin: 0 16px;
    padding: 10px 12px;
    margin-top: 10px;
    font-size: 14px;
    color: #666666;
    background-color: #ffffff;
    border-radius: 10px;
    p {
      height: 30px;
      line-height: 30px;
    }
  }
  .notHave {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 97px;
    img {
      width: 160px;
      height: 160px;
    }
    p {
      font-size: 17px;
      color: #ff3838;
    }
  }
}
</style>

<style scoped>
.container >>> .van-hairline--surround::after {
  border-radius: 25px;
}
.content >>> .van-tab {
  font-size: 17px;
  font-weight: 800;
}
.content >>> .van-tabs__wrap {
  position: fixed;
  top: 199px;
  left: 0;
  width: 100%;
  height: 45px;
  z-index: 666;
}
.content >>> .van-list {
  padding-top: 55px;
  min-height: calc(100vh - 254px);
}
.cover >>> .van-tabs__wrap {
  top: 155px !important;
}
.cover >>> .van-list {
  min-height: calc(100vh - 210px) !important;
}
</style>